import React, { useEffect, useRef } from "react";
import { animate, useInView } from "framer-motion";
import "./ReviewCounter.css";

export const ReviewCounter = ({ data, title }) => {
  return (
    <div className="ReviewCounter-container">
      <div className="ReviewCounter-stats-container">

        {title && <h4>{title}</h4>}

        {data && data.map((item, idx) => {

          const is_divider = idx + 1 < data?.length

          return (
            <>
              <Stat
                num={item.num}
                suffix=""
                subheading={item.label}
              />
              {is_divider && <div className="ReviewCounter-divider" />}
            </>
          )
        })}
        {/* <Stat
          num={45}
          suffix="%"
          subheading="Lorem ipsum dolor sit amet consectetur"
        />
        <div className="ReviewCounter-divider" />
        <Stat
          num={15.5}
          decimals={1}
          suffix="K+"
          subheading="Lorem ipsum dolor sit amet consectetur"
        />
        <div className="ReviewCounter-divider" />
        <Stat
          num={20}
          suffix="B+"
          subheading="Lorem ipsum dolor sit amet consectetur"
        /> */}
      </div>
    </div>
  );
};

const Stat = ({ num, suffix, decimals = 0, subheading }) => {
  const ref = useRef(null);
  const isInView = useInView(ref);

  useEffect(() => {
    if (!isInView) return;

    animate(0, num, {
      duration: 2.5,
      onUpdate(value) {
        if (!ref.current) return;

        ref.current.textContent = value.toFixed(decimals);
      },
    });
  }, [num, decimals, isInView]);

  return (
    <div className="ReviewCounter-stat">
      <p className="ReviewCounter-stat-number">
        <span ref={ref}></span>
        {suffix}
      </p>
      <p className="ReviewCounter-stat-subheading">{subheading}</p>
    </div>
  );
};
